import { api } from "../api/client";
import { useAsync } from "../lib/useAsync";
import { useState } from "react";

export function DiscoveryReview() {
  const { data, loading, error, reload } = useAsync(() => api.reviewQueue(), []);
  const [msg, setMsg] = useState<string>();

  const act = async (id: string, action: "approve" | "reject") => {
    setMsg(undefined);
    try {
      if (action === "approve") await api.approveDiscovered(id);
      else await api.rejectDiscovered(id);
      reload();
    } catch (e) {
      setMsg((e as Error).message);
    }
  };

  return (
    <div>
      <h1>Discovery review queue</h1>
      <p className="muted">
        Low-confidence discovered meets awaiting admin approval. Approve to
        publish; reject to hide (won't resurface on re-crawl).
      </p>
      {loading && <p>Loading…</p>}
      {error && <p className="error">{error}</p>}
      {msg && <p className="error">{msg}</p>}
      {data && <p className="muted">{data.count} awaiting review</p>}
      {data?.items.map((m) => (
        <div key={m.discoveryId} className="card">
          <div className="row spread">
            <strong>{m.title}</strong>
            <span className="badge">
              {m.state} · conf {Math.round(m.confidence * 100)}%
            </span>
          </div>
          <p className="muted">
            {m.startDate}
            {m.venueName ? ` · ${m.venueName}` : ""}
            {m.city ? `, ${m.city}` : ""} · {m.sourceName}
          </p>
          {m.rawExcerpt && (
            <p className="muted" style={{ fontSize: "0.8rem" }}>
              {m.rawExcerpt.slice(0, 200)}
            </p>
          )}
          <div className="row">
            <button onClick={() => act(m.discoveryId, "approve")}>
              Approve
            </button>
            <button
              className="danger"
              onClick={() => act(m.discoveryId, "reject")}
            >
              Reject
            </button>
            <a href={m.sourceUrl} target="_blank" rel="noreferrer">
              View source
            </a>
          </div>
        </div>
      ))}
      {data && data.items.length === 0 && (
        <p className="muted">Nothing awaiting review. 🎉</p>
      )}
    </div>
  );
}
